import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'
import { push } from 'react-router-redux'
import { PATHS } from '../Config/Routing/paths'
import { authorization } from '../Module/Auth/Auth'
import { pushApiError } from './../Reducers/Errors/actions'

/**
 * Any code that uses this middleware should not require a refresh from the
 * server and should adhere to optimistic updates.
 */
const createMiddleware = options => ({ dispatch }) => next => action => {
  const { actions, fetchMethod, isOptimistic } = options
  const [ACTION, ACTION_SUCCESS, ACTION_FAILURE] = actions

  if (action.type === ACTION) {
    next(action)

    return new Promise(async (resolve, reject) => {
      try {
        if (!isOptimistic) dispatch(incUIBlockCounter())
        // Api key would be better to come from state
        var response = await fetchMethod(
          authorization.getAPIKey(),
          action.payload,
        )

        if (response.status == 202) {
          // Will be processed later so don't do anything
          if (!isOptimistic) dispatch(decBlockCounter())
          return resolve()
        }

        var result = await response.json()
        const { status } = response

        if (status === 401) {
          authorization.logout()
          return dispatch(push(PATHS.main.login))
        }

        if (status === 404) {
          dispatch(push(PATHS.dashboard.dashboard + PATHS.dashboard.notFound))
          return reject()
        }
        if (status === 403) {
          dispatch(
            push(PATHS.dashboard.dashboard + PATHS.dashboard.notAuthorised),
          )
          return reject()
        }

        if (status >= 400 && status <= 512) {
          dispatch(pushApiError(result.message))
          reject()
        }

        if (result.errors && result.errors[0]) {
          dispatch(pushApiError(result.errors[0].message))
          reject()
        }

        dispatch({
          type: ACTION_SUCCESS,
          payload: action.payload,
          result,
        })
        resolve(result)
      } catch (err) {
        console.error(err)
        dispatch(pushApiError(err.message))
        if (ACTION_FAILURE)
          dispatch({
            type: ACTION_FAILURE,
            payload: err,
          })
        reject(err)
      } finally {
        if (!isOptimistic) dispatch(decBlockCounter())
      }
    })
  }
  return next(action)
}

export default createMiddleware
